import NextLink from 'next/link';

// this component is intended to be injected into chakra links using the "as" prop
// https://chakra-ui.com/docs/components/link#usage-with-nextjs
export default NextLink;
